<template>
  <div class="team">
    <div class="team__header">
      <UserInfo
        :userPhoto="teamInfo.photo"
        :username="teamInfo.title"
        :desc="teamInfo.desc"
        size="lg"
      />

      <div
        class="team-block"
        @click="onBlock"
      >
        <span class="team-block__text">
          {{ teamInfo.isBlocked ? 'Разблокировать' : 'Заблокировать команду' }}
        </span>
        <BaseIcon icon="stop" class="team-block__icon" />
      </div>
    </div>

    <AppMenu
      modelValue="list"
      :items="[ { value: 'list', label: 'Список участников' } ]"
      class="team__menu"
    />

    <AppTable
      v-if="tableData.length > 0"
      :fields="tableFields"
      :items="tableData"
    >
      <template #name="data">
        <BaseLink :href="`/user/${data.id}`">
          {{ data.name }}
        </BaseLink>
      </template>
    </AppTable>
    <p v-else class="h3">В команде нет участников.</p>

    <div
      v-if="paginationTotal / paginationPerPage > 1"
      class="team__pagination-wrapper"
    >
      <AppPagination
        v-model="paginationCurrent"
        :totalRows="paginationTotal"
        :perPage="paginationPerPage"
      />
    </div>
  </div>
</template>

<script>
import UserInfo from '@/components/UserInfo'
import AppTable from '@/components/AppTable'
import AppMenu from '@/components/AppMenu'
import BaseIcon from '@/components/Base/BaseIcon'
import AppPagination from '@/components/Base/AppPagination'

export default {
  name: 'TeamPage',
  components: {
    AppPagination,
    BaseIcon,
    AppMenu,
    AppTable,
    UserInfo
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'Имя', slot: true },
        { key: 'surname', label: 'Фамилия' },
        { key: 'login', label: 'Логин' },
        { key: 'email', label: 'Почта' },
        { key: 'date', label: 'Дата создания' }
      ],
      tableData: [],
      teamInfo: {
        desc: null,
        title: null,
        photo: null,
        isBlocked: false
      },
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    requestBody () {
      return {
        id: this.$route.params.id,
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent
      }
    }
  },
  watch: {
    /** Отслеживанию изменение св-ва и подтягиваю новые данные таблицы */
    paginationCurrent: 'fetchMembers'
  },
  async created () {
    try {
      this.$store.commit('loading/setLoad', true)
      await this.fetchMembers()
    } finally {
      this.$store.commit('loading/setLoad', false)
    }
  },
  methods: {
    async fetchMembers () {
      try {
        const { data } = await this.$api.team.members(this.requestBody)
        const list = data?.list ?? []
        this.paginationTotal = data.pages * this.paginationPerPage

        this.teamInfo.desc = data?.total ? `${data.total} участника(ов)` : ''
        this.teamInfo.title = data?.team?.title ?? ''
        this.teamInfo.photo = data?.team?.photo?.url ?? ''
        this.teamInfo.isBlocked = data?.team?.isBlock ?? false

        this.tableData = list.map(item => {
          const id = item?.id
          const name = item?.name
          const surname = item?.surname
          const login = item?.username
          const email = item?.email
          const date = item?.createdAt

          return {
            id,
            name,
            surname,
            login,
            email,
            date
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async onBlock () {
      try {
        if (this.teamInfo.isBlocked) {
          await this.$api.team.unblock(this.$route.params.id)
        } else {
          await this.$api.team.block(this.$route.params.id)
        }

        await this.fetchMembers()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.team {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__menu {
    margin: 20px 0 40px;
  }

  &-block {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &__text {}
    &__icon {
      width: 14px;
      margin-left: 12px;
    }
  }

  &__pagination-wrapper {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
